// Groups the Country facet picklist by continent. Country names match the
// labels emitted by /api/inpact/facets/countries (Salesforce
// Country_of_Residence__c values). Geographic continents (UN M49-ish) with the
// Middle East folded into Asia. Anything unmapped falls into "Other" so it
// stays selectable — add an entry when a new country appears.

export interface Continent {
  key: string;
  label: string;
  emoji: string;
}

// Display order of the groups in the facet.
export const CONTINENTS: readonly Continent[] = [
  { key: "europe", label: "Europe", emoji: "🇪🇺" },
  { key: "americas", label: "Americas", emoji: "🌎" },
  { key: "asia", label: "Asia & Middle East", emoji: "🌏" },
  { key: "africa", label: "Africa", emoji: "🌍" },
  { key: "oceania", label: "Oceania", emoji: "🇦🇺" },
  { key: "other", label: "Other", emoji: "🏳️" },
];

const NAME_TO_CONTINENT: Record<string, string> = {
  // Europe
  Albania: "europe", Austria: "europe", Belarus: "europe", Belgium: "europe",
  "Bosnia and Herzegovina": "europe", Bulgaria: "europe", Croatia: "europe",
  Cyprus: "europe", Czechia: "europe", "Czech Republic": "europe",
  Denmark: "europe", Estonia: "europe", Finland: "europe", France: "europe",
  Germany: "europe", Greece: "europe", Hungary: "europe", Iceland: "europe",
  Ireland: "europe", Italy: "europe", Latvia: "europe", Liechtenstein: "europe",
  Lithuania: "europe", Luxembourg: "europe", Malta: "europe", Moldova: "europe",
  Monaco: "europe", Montenegro: "europe", Netherlands: "europe",
  "The Netherlands": "europe", "North Macedonia": "europe", Norway: "europe",
  Poland: "europe", Portugal: "europe", Romania: "europe", Russia: "europe",
  "Russian Federation": "europe", "San Marino": "europe", Serbia: "europe",
  Slovakia: "europe", Slovenia: "europe", Spain: "europe", Sweden: "europe",
  Switzerland: "europe", Ukraine: "europe", "United Kingdom": "europe",
  // Americas
  Argentina: "americas", Bolivia: "americas", Brazil: "americas",
  Canada: "americas", Chile: "americas", Colombia: "americas",
  "Costa Rica": "americas", Cuba: "americas", "Dominican Republic": "americas",
  Ecuador: "americas", "El Salvador": "americas", Guatemala: "americas",
  Honduras: "americas", Jamaica: "americas", Mexico: "americas",
  Nicaragua: "americas", Panama: "americas", Paraguay: "americas",
  Peru: "americas", Uruguay: "americas", "United States": "americas",
  "United States of America": "americas", USA: "americas",
  Venezuela: "americas",
  // Asia & Middle East
  Afghanistan: "asia", Bahrain: "asia", Bangladesh: "asia", China: "asia",
  "Hong Kong": "asia", India: "asia", Indonesia: "asia", Iran: "asia",
  Iraq: "asia", Israel: "asia", Japan: "asia", Jordan: "asia",
  Kazakhstan: "asia", Kuwait: "asia", Lebanon: "asia", Malaysia: "asia",
  Nepal: "asia", Oman: "asia", Pakistan: "asia", Palestine: "asia",
  Philippines: "asia", Qatar: "asia", "Saudi Arabia": "asia",
  Singapore: "asia", "South Korea": "asia", "Sri Lanka": "asia",
  Syria: "asia", Taiwan: "asia", Thailand: "asia", Turkey: "asia",
  UAE: "asia", "United Arab Emirates": "asia", Vietnam: "asia", Yemen: "asia",
  // Africa
  Algeria: "africa", Angola: "africa", Cameroon: "africa", Egypt: "africa",
  Ethiopia: "africa", Ghana: "africa", "Ivory Coast": "africa",
  Kenya: "africa", Liberia: "africa", Libya: "africa", Morocco: "africa",
  Mozambique: "africa", Nigeria: "africa", Rwanda: "africa", Senegal: "africa",
  "South Africa": "africa", Sudan: "africa", Tanzania: "africa",
  Tunisia: "africa", Uganda: "africa", Zambia: "africa", Zimbabwe: "africa",
  // Oceania
  Australia: "oceania", Fiji: "oceania", "New Zealand": "oceania",
  "Papua New Guinea": "oceania",
};

export function continentOf(country: string): string {
  return NAME_TO_CONTINENT[country] ?? "other";
}
